import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './pages/Pages.css';
import Home from './pages/Home';
import Work from './pages/Work';
import Writings from './pages/writings/index';
import BlogPost1 from './pages/writings/BlogPost1';
import BCIs from './pages/writings/BCIs';
import Photography from './pages/photography/index';
import ItalyGreece from './pages/photography/ItalyGreece';
import BayArea from './pages/photography/BayArea';
import USVarious from './pages/photography/USVarious';
import Books from './pages/Books';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/writings" element={<Writings />} />
          <Route path="/writings/blog-post-1" element={<BlogPost1 />} />
          <Route path="/writings/bcis" element={<BCIs />} />
          <Route path="/photography" element={<Photography />} />
          <Route path="/photography/italy-greece" element={<ItalyGreece />} />
          <Route path="/photography/bay-area" element={<BayArea />} />
          <Route path="/photography/us-various" element={<USVarious />} />
          <Route path="/books" element={<Books />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
